var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:{ 'checkbox--first': _vm.isFirst }},[_c('label',{staticClass:"checkbox__label"},[_c('input',{staticClass:"checkbox__input",attrs:{"type":"checkbox","required":_vm.required},domProps:{"checked":_vm.value,"value":_vm.value},on:{"change":function($event){_vm.$emit('input', !_vm.value)}}}),_vm._v(" "),_c('span',{staticClass:"checkbox__custom",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2defdbec","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Checkbox.vue
// module id = null
// module chunks = 